import { inject, Injectable } from "@angular/core";
import { OrganisationSettingData } from "@models/settings/organisation-setting-data";
import { ToastrService } from "ngx-toastr";
import { catchError, EMPTY, Observable, of, tap } from "rxjs";
import { SettingsApiService } from "./settings-api.service";

@Injectable({ providedIn: 'root' })
export class OrganisationSettingsService {
  settingsService = inject(SettingsApiService);
  toastr = inject(ToastrService);

  private organisationSettings: OrganisationSettingData | null = null;

  getOrganisationSettings(): Observable<OrganisationSettingData> {
    if (this.organisationSettings) {
      return of(this.organisationSettings);
    }

    return this.settingsService.getOrganisationSettings()
      .pipe(
        tap((settings) => {
          this.organisationSettings = settings;
        }),
        catchError(() => {
          this.toastr.error('Failed to load organisation settings');
          return EMPTY;
        })
      );
  }
}
